import React from 'react';

function Privacy() {
  return (
    <div className="p-6 md:p-10 text-gray-800 font-sans">
      <h1 className="text-2xl md:text-3xl font-bold mb-4">durapot Privacy Policy</h1>
      <p className="text-lg mb-4">
        You are here because you want to learn more about what we do with your personal information and who controls that information. Within this policy, we hope to give you a clear understanding of how your data is handled and what options you have as a valued customer.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Who Are We?</h2>
      <p className="text-lg">
        durapot Webuy Entertainment Private Limited (referred to as we or us in this policy), a company incorporated in India with the registration number U72300MH2010PTC204721, located at B-1, Ground Floor, Todi Estate, Sun Mill Compound, Lower Parel (W), Mumbai, Maharashtra 400013, collects, uses, and is responsible for certain personal information about you. When we do so, we are regulated under the Digital Personal Data Protection Act 2023, which is applicable in India, and we are responsible as "Data Fiduciary" of that personal information for the purposes of those laws.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">How Do We Collect Your Data?</h2>
      <p className="text-lg">
        We collect most of this personal information directly from you – in person, by telephone, text, email, or via our website and apps. We only ask for the information that is relevant to help us build an account with you.
      </p>

      <h3 className="text-lg font-semibold mt-4">Examples of personal information collected:</h3>
      <ul className="list-disc pl-6 text-lg">
        <li>Legal Name</li>
        <li>Residential address, phone number</li>
        <li>Email address</li>
        <li>IP address</li>
        <li>Aadhaar, Pan card information</li>
        <li>Bank account details - Account number, IFSC code</li>
        <li>Cookies</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Our Use of Personal Information</h2>
      <p className="text-lg">
        We can only use your personal information if we have a proper reason for doing so, such as:
      </p>
      <ul className="list-disc pl-6 text-lg">
        <li>To comply with our legal and regulatory obligations</li>
        <li>For the performance of our contract with you</li>
        <li>Where you have given consent</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Do We Share Your Information?</h2>
      <p className="text-lg">
        We will not share any of your data without your consent, except in the following cases:
      </p>
      <ul className="list-disc pl-6 text-lg">
        <li>External auditors to improve our systems</li>
        <li>Third-party groups for service quality assessment</li>
        <li>Law enforcement investigations</li>
        <li>Courier partners for delivery issues</li>
        <li>Google Customer Match for updated offers</li>
      </ul>

      <p className="text-lg mt-6">
        For any concerns or queries regarding your privacy, please reach out to us.
      </p>
    </div>
  );
}

export default Privacy;
